import React from "react";
import Input from "material-ui/Input";

const CInput = props => {
  return <Input disableUnderline {...props} />;
};

export default CInput;



// WEBPACK FOOTER //
// ./src/uis/CInput.jsx